import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../../components/Footer";
import AboutSection from "./components/AboutSection";
import DownloadSection from "./components/DownloadSection";
import FormSection from "./components/FormSection";
import HeroSection from "./components/HeroSection";
import OrgPackages from "./components/OrgPackages";
import OrgSection from "./components/OrgSection";
import SolutionsSection from "./components/SolutionsSection";
import VideoSection from "./components/VideoSection";

export default function Home() {
  const location = useLocation();
  const videoRef = useRef(null); // Ref to control the video element

  const [isPlaying, setIsPlaying] = useState(false);

  // Section navigation state (left fixed dots)
  const [sectionsList, setSectionsList] = useState([]);
  const [activeSectionIndex, setActiveSectionIndex] = useState(0);
  const sectionRefs = useRef([]);
  const sectionLabels = {
    hero: "خانه",
    about: "درباره",
    features: "ویژگی‌ها",
    video: "ویدیو",
    org: "سازمان‌ها",
    solutions: "راهکارها",
    // comments: "نظرات",
    form: "فرم",
    downloadSection: "دانلود",
    foot: "پاورقی",
  };

  useEffect(() => {
    // Check if the URL contains the special tag
    if (location.hash === "#form") {
      const section = document.getElementById("form");
      if (section) {
        // Scroll to the section
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else if (location.hash === "#contact") {
      // Scroll to the footer
      const section = document.getElementById("footer");
      if (section) {
        // Scroll to the section
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.hash]);

  // Build a list of top-level fullpage sections and observe them
  useEffect(() => {
    const containerSelector = ".fullpage-scroll-container";
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const secs = Array.from(container.querySelectorAll("section[id]"));
    sectionRefs.current = secs;
    setSectionsList(secs);

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const idx = secs.indexOf(entry.target);
            if (idx >= 0) setActiveSectionIndex(idx);
          }
        });
      },
      { threshold: 0.5 }
    );

    secs.forEach(s => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  const scrollToSection = idx => {
    const s = sectionRefs.current[idx];
    if (s) {
      s.scrollIntoView({ behavior: "smooth", block: "start" });
      setActiveSectionIndex(idx);
    }
  };

  const handlePlayClick = () => {
    if (videoRef.current) {
      videoRef.current.play(); // Play the video
      setIsPlaying(true); // Hide the play button and absolute div
    }
  };

  return (
    <div className="fullpage-scroll-container h-dvh sidepanel">
      {/* Left fixed dot navigation (desktop) */}
      <div className="fixed left-6 top-1/2 -translate-y-1/2 z-50 hidden md:flex flex-col gap-3">
        {sectionsList.map((s, i) => (
          <button
            key={s.id || i}
            title={sectionLabels[s.id] || s.id || `section-${i}`}
            onClick={() => scrollToSection(i)}
            className={`rounded-full transition-all duration-300 flex items-center justify-center ${
              activeSectionIndex === i
                ? "bg-myGreen34 w-4 h-4 scale-105"
                : "bg-[#d1d5db] w-3 h-3"
            }`}
            aria-label={`Scroll to ${sectionLabels[s.id] || s.id || i}`}
          ></button>
        ))}
      </div>

      <HeroSection />

      <AboutSection />

      <VideoSection
        videoRef={videoRef}
        isPlaying={isPlaying}
        handlePlayClick={handlePlayClick}
      />

      <OrgSection />

      <SolutionsSection />

      <OrgPackages />

      {/* <CommentsSection /> */}

      <FormSection />

      <DownloadSection />

      {/* Footer */}
      <section className={`w-full md:min-h-screen flex items-center`} id="foot">
        <Footer scrollToSection={scrollToSection} />
      </section>
    </div>
  );
}
